let initialState = {result:{},loading:true};

const GetTestByIdReducer = (state=initialState,action) => {
    switch(action.type)
    {
        case 'GET_TEST_BY_ID':
            {
                state.result=action.payload;
                state.loading=false;
                return {...state};
            }
        default:
             return state;
    }
}

export default GetTestByIdReducer;